import { render } from "./CollectionLayoutSelect.vue?vue&type=template&id=2f31bdc5"
import script from "./CollectionLayoutSelect.vue?vue&type=script&lang=js"
export * from "./CollectionLayoutSelect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__